import { render, staticRenderFns } from "./AppointmentsQueue.vue?vue&type=template&id=736fe8a3&scoped=true"
import script from "./AppointmentsQueue.vue?vue&type=script&lang=ts"
export * from "./AppointmentsQueue.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentsQueue.vue?vue&type=style&index=0&id=736fe8a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fe8a3",
  null
  
)

export default component.exports